import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTextiles = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_1838_350)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M19.9121 12.0727L16.7105 9.99994L19.9121 7.92708C20.2801 7.68896 20.5002 7.29497 20.5002 6.87342C20.5002 6.45192 20.2801 6.05794 19.9121 5.81981L11.268 0.222931C10.8098 -0.0743103 10.1907 -0.0743103 9.73252 0.222931L1.08842 5.8198C0.720427 6.05794 0.500244 6.45192 0.500244 6.87342C0.500244 7.29497 0.720427 7.68896 1.08842 7.92709L4.28997 9.99995L1.08842 12.0727C0.720427 12.3108 0.500244 12.7048 0.500244 13.1267C0.500244 13.5483 0.720427 13.9423 1.08842 14.1804L9.73334 19.7777C9.96242 19.9259 10.2313 20 10.5002 20C10.7692 20 11.0381 19.9259 11.268 19.7773L19.9121 14.1804C20.2801 13.9423 20.5002 13.5483 20.5002 13.1268C20.5002 12.7048 20.2801 12.3108 19.9121 12.0727ZM1.76759 6.86294L10.4117 1.26601C10.4369 1.2502 10.4686 1.24211 10.5002 1.24211C10.5319 1.24211 10.5636 1.2502 10.5888 1.26602L19.2532 6.86575C19.2524 6.86778 19.2467 6.87506 19.2329 6.88401L10.5888 12.4809C10.5385 12.5125 10.4621 12.5125 10.4117 12.4809L1.76759 6.86294ZM19.2329 13.1373L10.5896 18.7338C10.5393 18.7662 10.462 18.7658 10.4117 18.7342L1.76759 13.1158L5.43504 10.7414L9.73253 13.524C9.96161 13.6726 10.2313 13.7471 10.5002 13.7471C10.7692 13.7471 11.0389 13.6726 11.268 13.524L15.5699 10.7385L19.2532 13.1191C19.2524 13.1211 19.2467 13.1284 19.2329 13.1373Z",
			fill: "black"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1838_350",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 21,
			height: 20,
			fill: "white"
		})
	}) })]
});
export default SvgTextiles;
